import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import Swal from 'sweetalert2';
import { userLimits } from './../uitls/userLimits';
import DiscountModal from './DiscountModal';
import EditMemberModal from './EditMemberModal';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HistoryIcon from '@mui/icons-material/History';
import AddShoppingCartModal from './AddShoppingCartModal';
import moment from 'moment';
import AddNewMemberModal from './AddNewMemberModal';
import BulkPointsModal from './BulkPointsModal';
import MemberOrderPanel from './MemberOrderPanel';
import { ExportToCsv } from 'export-to-csv';
import { CloudDownload } from '@mui/icons-material';
import ModernTable, { ModernPageHeader, ModernPageContainer } from '../components/ModernTable';
import { Box, Chip, alpha, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PeopleIcon from '@mui/icons-material/People';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import StarsIcon from '@mui/icons-material/Stars';

const getAllEmployeesURL = `/clientUser/getClients`;

export default function ViewMember(props) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  const dbaUser = user.dba;
  const { id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Members',
    'edit_member'
  );

  const pinOnlyEmail = ['tianlangwu001@gmail.com', 'shivangum@alpskiosks.com', 'rachel@potere.us'];

  const isPinOnly = pinOnlyEmail.includes(id);

  let history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [reflesh, setReflesh] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [rowdata, setrowdata] = useState(null);
  const [isMultiple, setIsMultiple] = useState(false);
  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_member') ? localStorage.getItem('table_view_member') : 10
  );

  const [mobile, setMobile] = useState(false);

  const [showSetting, setShowSetting] = useState(false);
  const [showAddCart, setShowAddCart] = useState(false);
  const [showAddNew, setShowAddNew] = useState(false);
  const [showBulkPoints, setShowBulkPoints] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);

  useEffect(() => {
    localStorage.setItem('table_view_member', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'post',
        url: getAllEmployeesURL,
        data: {
          id: id,
          dba: dbaUser,
        },
      }).then((res) => {
        if (!isCancelled) {
          console.log('useruser', res.data);
          setEmployees(res.data?.members);
          setMobile(res.data?.mobileSetting);
          setIsLoading(true);
        }
      });
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteUser = async (id) => {
    await request({
      method: 'delete',
      url: `/deleteClientUser`,
      data: {
        _id: id,
      },
    })
      .then(() => {
        Swal.fire({
          text: `The user has been successfully deleted`,
          icon: 'success',
        });
        reflesh ? setReflesh(false) : setReflesh(true);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          text: err.response?.data?.error?.message || 'Something went wrong',
          icon: 'error',
        });
      });
  };

  const handleDownloadCSV = () => {
    // Prepare data as array of objects for export
    const exportData = employees.map((row) => {
      const obj = {};
      columns.forEach((col) => {
        let value = row[col.field];
        // Format date fields
        if ((col.field === 'last_purchase' || col.field === 'createdAt') && value) {
          value = moment(value).format('MM/DD/YYYY');
        }
        obj[col.title] = value === undefined || value === null ? '' : value;
      });
      return obj;
    });
    const options = {
      filename: 'Members_csv',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(exportData);
  };

  let columns = [
    {
      title: 'Username',
      field: 'username',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          {rowData.username}
        </Typography>
      ),
    },
    {
      title: 'Email',
      field: 'email',
      editable: 'never',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary, fontFamily: 'monospace', fontSize: '0.875rem' }}
        >
          {rowData.email}
        </Typography>
      ),
    },
    {
      title: 'Phone',
      field: 'phone',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.phone || '-'}
        </Typography>
      ),
    },
    {
      title: 'Points',
      field: 'points',
      editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.points || 0}
          sx={{
            fontWeight: 600,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Member Since',
      field: 'createdAt',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
          {rowData.createdAt ? moment(rowData.createdAt).format('MM/DD/YYYY') : '-'}
        </Typography>
      ),
    },
    {
      title: 'Last Purchase',
      field: 'last_purchase',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
          {rowData.last_purchase ? moment(rowData.last_purchase).format('MM/DD/YYYY') : '-'}
        </Typography>
      ),
    },
    {
      title: 'Orders',
      field: 'order_qtt',
      editable: 'never',
      width: 90,
      headerStyle: { width: 90, minWidth: 90 },
      cellStyle: { width: 90, minWidth: 90 },
      render: (rowData) => (
        <Chip
          label={rowData.order_qtt || 0}
          size="small"
          sx={{
            height: 22,
            minWidth: 34,
            fontWeight: 600,
            fontSize: '0.75rem',
            '& .MuiChip-label': { px: 0.75 },
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
  ];

  if (isPinOnly) {
    columns = [
      {
        title: 'Username',
        field: 'username',
        editable: 'never',
        render: (rowData) => (
          <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
            {rowData.username}
          </Typography>
        ),
      },
      {
        title: 'Email',
        field: 'email',
        editable: 'never',
        render: (rowData) => (
          <Typography
            variant="body2"
            sx={{ color: theme.palette.text.secondary, fontFamily: 'monospace', fontSize: '0.875rem' }}
          >
            {rowData.email}
          </Typography>
        ),
      },
      {
        title: 'Phone',
        field: 'phone',
        editable: 'never',
        render: (rowData) => (
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {rowData.phone || '-'}
          </Typography>
        ),
      },
      {
        title: 'Pin',
        field: 'pin',
        editable: 'never',
        render: (rowData) => (
          <Chip
            label={rowData.pin}
            sx={{
              fontWeight: 600,
              fontFamily: 'monospace',
              backgroundColor: alpha(theme.palette.warning.main, 0.12),
              color: theme.palette.warning.dark,
              border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            }}
          />
        ),
      },
      {
        title: 'Member Since',
        field: 'createdAt',
        editable: 'never',
        render: (rowData) => (
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
            {rowData.createdAt ? moment(rowData.createdAt).format('MM/DD/YYYY') : '-'}
          </Typography>
        ),
      },
      {
        title: 'Last Purchase',
        field: 'last_purchase',
        editable: 'never',
        render: (rowData) => (
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
            {rowData.last_purchase ? moment(rowData.last_purchase).format('MM/DD/YYYY') : '-'}
          </Typography>
        ),
      },
    ];
  }

  return (
    <ModernPageContainer>
      {!isloading && <LoadingIcon />}

      {/* Header Section with Multiple Buttons */}
      <ModernPageHeader
        title={tableTitle || 'Members'}
        subtitle="Manage member accounts, points, and order history"
        icon={PeopleIcon}
        buttons={[
          {
            text: 'Settings',
            icon: SettingsIcon,
            variant: 'outlined',
            onClick: () => {
              if (!access) return Swal.fire('', "You don't have permission", 'error');
              setShowSetting(true);
            },
          },
          {
            text: 'Add Member',
            icon: AddIcon,
            variant: 'outlined',
            onClick: () => {
              if (!access) return Swal.fire('', "You don't have permission", 'error');
              setShowAddNew(true);
            },
          },
          {
            text: 'Add Order (All)',
            icon: ShoppingCartIcon,
            variant: 'outlined',
            onClick: () => {
              if (!access) return Swal.fire('', "You don't have permission", 'error');
              setrowdata(null);
              setShowAddCart(true);
            },
          },
        ]}
      />

      {/* Modern Table */}
      <Box sx={{ mt: 3 }}>
        <ModernTable
          columns={columns}
          data={employees}
          onRowsPerPageChange={setPagination}
          localization={{ body: { editRow: { deleteText: 'Are you sure to delete this user' } } }}
          editable={{
            onRowDelete: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  deleteUser(newData._id);
                  resolve();
                }, 1000);
              }),
          }}
          actions={[
            {
              icon: CloudDownload,
              tooltip: 'Download CSV',
              isFreeAction: true,
              onClick: handleDownloadCSV,
            },
            {
              icon: 'edit',
              tooltip: 'Edit Member',
              position: 'row',
              onClick: (event, rowdata) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setrowdata(rowdata);
                setshow(true);
              },
            },
            {
              icon: ShoppingCartIcon,
              tooltip: 'Add Order',
              position: 'row',
              onClick: (event, rowdata) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setShowAddCart(true);
                setrowdata(rowdata);
              },
            },
            {
              icon: HistoryIcon,
              tooltip: 'Order History',
              position: 'row',
              onClick: (event, rowdata) => {
                window.open(`/dashboard/memberorder/${rowdata._id}`, '_blank');
              },
            },
            {
              icon: () => <StarsIcon />,
              tooltip: 'Edit points for selected members',
              position: 'toolbarOnSelect',
              onClick: (event, data) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                const rows = Array.isArray(data) ? data : [data];
                setSelectedMembers(rows);
                setShowBulkPoints(true);
              },
            },
          ]}
          detailPanel={[
            {
              tooltip: 'Order history',
              render: ({ rowData }) => <MemberOrderPanel member={rowData} />,
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            selection: true,
            rowStyle: (rowData) => {
              if (rowData.dba) {
                return {
                  backgroundColor: alpha(theme.palette.info.main, 0.05),
                  borderLeft: `4px solid ${theme.palette.info.main}`,
                };
              }
            },
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100],
          }}
        />
        {/* Back Button */}
        <Box sx={{ mt: 3 }}>
          <BackButton />
        </Box>
      </Box>

        {/* Modals */}
        <EditMemberModal
          user={user}
          id={id}
          show={show}
          data={rowdata}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setshow(false);
          }}
        />
        <AddShoppingCartModal
          isMultiple={isMultiple}
          user={user}
          id={id}
          show={showAddCart}
          data={rowdata}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowAddCart(false);
          }}
        />
        <DiscountModal
          user={user}
          id={id}
          show={showSetting}
          data={mobile}
          setMobile={setMobile}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowSetting(false);
          }}
        />
        <AddNewMemberModal
          user={user}
          id={id}
          show={showAddNew}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowAddNew(false);
          }}
        />
        <BulkPointsModal
          id={id}
          members={selectedMembers}
          show={showBulkPoints}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowBulkPoints(false);
          }}
        />
    </ModernPageContainer>
  );
}
